export const SHOPINFO_SYNC_KEY = 'dp:shopinfo-sync';

export function notifyShopInfoChanged() {
  localStorage.setItem(SHOPINFO_SYNC_KEY, String(Date.now()));
}